// Deciding whether a parking session belongs to a partner's lots.
//
// The partner views used to answer this by comparing `session.lotName` to the
// partner's lot names — string equality on a user-editable field. Two lots
// sharing a name across partners cross-contaminate, and renaming a lot
// silently orphans its history. `lotID` (the lot document id) is the real key
// and is what the mobile app writes; the name comparison is kept only as a
// fallback for older session documents written before lotID existed.

export interface ScopedSession {
  lotID?: string;
  lotName?: string;
}

export function sessionBelongsToLots(
  session: ScopedSession,
  lotIds: Set<string>,
  lotNames: Set<string>
): boolean {
  if (session.lotID) return lotIds.has(session.lotID);
  return !!session.lotName && lotNames.has(session.lotName);
}

/** Collect both keys from a partner's lot documents in one pass. */
export function collectLotKeys(
  docs: { id: string; data: () => any }[]
): { lotIds: Set<string>; lotNames: Set<string> } {
  const lotIds = new Set<string>();
  const lotNames = new Set<string>();
  docs.forEach((d) => {
    lotIds.add(d.id);
    const name = d.data()?.lotName;
    if (name) lotNames.add(name);
  });
  return { lotIds, lotNames };
}
